import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["buttonProps", "className"],
  _excluded2 = ["buttonProps", "className"],
  _excluded3 = ["service", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import DixuCard from "../DixuCard/DixuCard";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuRibbon from "../DixuRibbon/DixuRibbon";
import DixuText from "../DixuText/DixuText";
import DixuTitle from "../DixuTitle/DixuTitle";
import { useTranslation } from "../../i18n";
import React from 'react';
import { LISTING_TYPE, SERVICE_PACKAGE } from "../../utils/DixuConstants";
import { formatPrice, getNumericPriceForCity } from "../../utils/MoneyUtils";
import SellerManIcon from "../../public/decorative/seller_man.svg";
import RealtorWomanIcon from "../../public/decorative/realtor_woman.svg";
import DixuAndMeIcon from "../../public/images/dixu_and_me.svg";
import DixuAndRealtorIcon from "../../public/images/dixu_and_realtor.svg";
import { toRem } from "../../utils/Utils";
const DIXU_AND_ME_APARTMENT_PRICE = getNumericPriceForCity({
  type: LISTING_TYPE.APARTMENT,
  servicePackage: SERVICE_PACKAGE.DIXU_EASY
});
const DIXU_AND_ME_PROPERTY_PRICE = getNumericPriceForCity({
  type: LISTING_TYPE.PROPERTY,
  servicePackage: SERVICE_PACKAGE.DIXU_EASY
});
const DIXU_AND_REALTOR_APARTMENT_PRICE = getNumericPriceForCity({
  type: LISTING_TYPE.APARTMENT,
  servicePackage: SERVICE_PACKAGE.DIXU_PLUS
});
const DIXU_AND_REALTOR_PROPERTY_PRICE = getNumericPriceForCity({
  type: LISTING_TYPE.PROPERTY,
  servicePackage: SERVICE_PACKAGE.DIXU_PLUS
});
const DixuEasyCard = _ref => {
  let {
      buttonProps,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-service-package-card--easy', className);
  const {
    t
  } = useTranslation(['common']);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(SellerManIcon, {
    className: classNames('dixu-service-package-card__decoration', 'dixu-service-package-card__decoration--seller')
  }), /*#__PURE__*/React.createElement("div", {
    className: "dixu-service-package-card__content"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    color: "2-7",
    weight: "bold",
    align: "center",
    margin: "0",
    noSemantics: true,
    responsive: false
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement("span", {
    className: "vhidden"
  }, t('common:Pricing.pricing:DixuEasy.Title')), /*#__PURE__*/React.createElement(DixuAndMeIcon, {
    style: {
      width: toRem(144),
      height: toRem(88)
    },
    className: "dixu-service-package-card__package-icon"
  }))))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [0, 40]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "4",
    color: "2-8",
    align: "center",
    weight: "bold",
    whiteSpace: "pre-line",
    className: "dixu-service-package-card__subtitle",
    block: true
  }, t('common:Pricing.DixuEasy.Subtitle'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16],
    direction: "column"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    flex: "0 1 auto"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "end",
    gutter: [16, 8],
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "5",
    color: "2-8",
    weight: "heavy",
    align: "right",
    responsive: true
  }, "Asunto-osake:")), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "9",
    color: "2-8",
    weight: "heavy",
    align: "right",
    style: {
      lineHeight: 0.6
    },
    responsive: true
  }, formatPrice(DIXU_AND_ME_APARTMENT_PRICE))))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "end",
    gutter: [16, 8],
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "5",
    color: "2-8",
    weight: "heavy",
    align: "right",
    responsive: true
  }, "Kiinteist\xF6:")), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "9",
    color: "2-8",
    weight: "heavy",
    align: "right",
    style: {
      lineHeight: 0.6
    },
    responsive: true
  }, formatPrice(DIXU_AND_ME_PROPERTY_PRICE))))))))))))), buttonProps && /*#__PURE__*/React.createElement("div", {
    className: "m-t-32"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
    type: 'primary',
    size: 'lg',
    block: false
  }, buttonProps), t('common:Pricing.StartSelling')))))));
};
DixuEasyCard.defaultProps = {};
const DixuPlusCard = _ref2 => {
  let {
      buttonProps,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-service-package-card--plus', className);
  const {
    t
  } = useTranslation(['common']);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(RealtorWomanIcon, {
    className: classNames('dixu-service-package-card__decoration', 'dixu-service-package-card__decoration--realtor')
  }), /*#__PURE__*/React.createElement("div", {
    className: "dixu-service-package-card__content"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuRibbon, {
    position: "top-left",
    angle: "30",
    top: 24,
    left: -20,
    className: "tablet-only"
  }, t('common:Pricing.DixuPlus.MostPopularPackage')), /*#__PURE__*/React.createElement(DixuRibbon, {
    position: "top-right",
    angle: "30",
    top: 30,
    right: -23,
    className: "desktop-only"
  }, t('common:Pricing.DixuPlus.MostPopularPackage')), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    color: "1-7",
    weight: "bold",
    align: "center",
    margin: "0",
    responsive: false,
    noSemantics: true
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement("span", {
    className: "vhidden"
  }, t('common:Pricing.DixuPlus.Title')), /*#__PURE__*/React.createElement(DixuAndRealtorIcon, {
    style: {
      width: toRem(144)
    },
    className: "dixu-service-package-card__package-icon"
  }))))))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 0
  }, /*#__PURE__*/React.createElement(DixuRibbon, {
    offset: 16
  }, t('common:Pricing.DixuPlus.MostPopularPackage'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    gutter: [0, 40]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "4",
    color: "1-7",
    align: "center",
    weight: "bold",
    whiteSpace: "pre-line",
    className: "dixu-service-package-card__subtitle",
    block: true
  }, t('common:Pricing.DixuPlus.Subtitle'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16],
    direction: "column"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "end",
    gutter: [16, 8],
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "5",
    color: "1-6",
    weight: "heavy",
    align: "right",
    responsive: true
  }, "Asunto-osake:")), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "9",
    color: "1-6",
    weight: "heavy",
    align: "right",
    style: {
      lineHeight: 0.6
    },
    responsive: true
  }, formatPrice(DIXU_AND_REALTOR_APARTMENT_PRICE))))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "end",
    gutter: [16, 8],
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "5",
    color: "1-6",
    weight: "heavy",
    align: "right",
    responsive: true
  }, "Kiinteist\xF6:")), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    family: "ropa",
    transform: "uppercase",
    font: "9",
    color: "1-6",
    weight: "heavy",
    align: "right",
    style: {
      lineHeight: 0.6
    },
    responsive: true
  }, formatPrice(DIXU_AND_REALTOR_PROPERTY_PRICE))))))))))))), buttonProps && /*#__PURE__*/React.createElement("div", {
    className: "m-t-32"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, _objectSpread({
    type: 'primary',
    size: 'lg',
    block: false,
    shadow: '1'
  }, buttonProps), t('common:Pricing.StartSelling')))))));
};
DixuPlusCard.defaultProps = {};
const DixuServicePackageCard = _ref3 => {
  let {
      service,
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  const classes = classNames('dixu-service-package-card', className);
  if (service === SERVICE_PACKAGE.DIXU_EASY) {
    return /*#__PURE__*/React.createElement(DixuEasyCard, _objectSpread({
      className: classes
    }, rest));
  }
  if (service === SERVICE_PACKAGE.DIXU_PLUS) {
    return /*#__PURE__*/React.createElement(DixuPlusCard, _objectSpread({
      className: classes
    }, rest));
  }
  return null;
};
DixuServicePackageCard.defaultProps = {
  shadow: '3',
  buttonProps: undefined
};
export default DixuServicePackageCard;